// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"b5d5551f","203":"a7012848","474":"2a1b6806","494":"0f8b5621","513":"a39322d6","544":"1ae01e3a","677":"f921293f"}[chunkId] + ".chunk.js";
};